import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import * as actionsMap from '../pushes/notifyActionOpenNotification/actions';
import { useClosingSync } from './useClosingSync';

export const useHandleActions = () => {
    const dispatch = useDispatch();
    const syncClose = useClosingSync();

    return useCallback(async (actions, { windowSessionId } = {}) => {
        for await (const action of actions) {
            for await (const [actionType, actionInfo] of Object.entries(action)) {
                const actionHandler = actionsMap[actionType];

                if (!actionType || !actionHandler) {
                    continue;
                }

                const popupsAction = await actionHandler({ actionInfo },
                    { syncClose: (token) => syncClose(token, { windowSessionId }) });

                if (popupsAction) {
                    try {
                        dispatch(popupsAction);
                    } catch (error) {
                        console.error('could not dispatch an action', actionType, actionInfo, error);
                    }
                }
            }
        }
    }, [
        dispatch,
        syncClose
    ]);
};
